export default "__VITE_ASSET__BxUvBJbU__"